import React from 'react';

export default ({ input, type, placeholder, className, initialValues, meta: { error, touched } }) => {
  return (
    <div>
      <input {...input} className={className} type={type} placeholder={placeholder} ></input>
      { touched && error && <div className="errorMsg">{ error }</div> }
    </div>
  )
}
